//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  GetItemDuration,
  GetItemName,
  GetItemSkinName,
  timeToCounter,
} from "@/tool";
export default {
  name: "roomConItem",
  data() {
    return {};
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        items: [],
        name: '',
        id: '',
        expir_time: '',
        userCount: 0
      }),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  filters: {
    GetItemDuration,
    GetItemName,
    GetItemSkinName,
    timeToCounter,
  },
};
